<script>
    import { Icon, Link, List, ListGroup, ListItem, Popover, f7 } from 'framework7-svelte';
    import { _, locale } from 'svelte-i18n';
     
    import nlFlag from '../assets/images/nl.svg';
    import gbFlag from '../assets/images/gb.svg';
    
    import { darkmode, setDarkMode } from '../utils/darkmode';
    import { logout, login } from '../utils/credentials';
    import { user } from '../auth/user';
    import { setLocale } from '../i18n/i18n.ts';

    const supportedLocales = ['nl', 'en'];
    
    function getLanguageIcon(language) {
        switch(language) {
            case 'nl':
                return nlFlag
            case 'en':
                return gbFlag
        }
    }
</script>

<Link class="link--level-deeper" iconOnly popoverOpen=".language-menu">
    <img style="width: 24px; height: 24px" src="{getLanguageIcon($locale)}">
</Link>
{#if $darkmode}
    <Link class="link--level-deeper" iconOnly on:click={() => setDarkMode(false)} iconMaterial="light_mode"></Link>
{:else}
    <Link class="link--level-deeper" iconOnly on:click={() => setDarkMode(true)} iconMaterial="dark_mode"></Link>
{/if}
<Link class="link--level-deeper" iconOnly popoverOpen=".settings-menu" iconMaterial="settings"></Link>

<Popover class="language-menu" style="width: 200px">
    <List ul={false}>
        {#each supportedLocales as supportedLocale}
            <ListItem
                    link="#"
                    popoverClose
                    on:click={() => setLocale(supportedLocale)}
            >
                {supportedLocale}
                <img
                        style="float: right; width: 24px; height: 24px"
                        src="{getLanguageIcon(supportedLocale)}"
                >
            </ListItem>
        {/each}
    </List>
</Popover>

<Popover class="settings-menu" style="width: 200px">
    <List ul={false}>
        <ListGroup>
            <ListItem link="/account" title="{$_('shared.MY_ACCOUNT')}">
                <Icon slot="media" material="person_outline" />
            </ListItem>
            {#if $user}
                <ListItem link="#" title="{$_('shared.LOGOUT')}" on:click={logout} popoverClose />
            {:else}
                <ListItem link="#" title="{$_('shared.LOGIN')}" on:click={login} popoverClose />
            {/if}
        </ListGroup>
    </List>
</Popover>
